import React from 'react';
import { Tree } from 'antd';
import {
  AppstoreOutlined,
  DatabaseOutlined,
  ThunderboltOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import type { DataNode } from 'antd/es/tree';
import type { TreeNode, TreeNodeType } from '../../shared/types';

interface ConfigTreeProps {
  treeData: TreeNode[];
  selectedKeys: React.Key[];
  expandedKeys: React.Key[];
  onSelect: (keys: React.Key[], info?: any) => void;
  onExpand: (keys: React.Key[]) => void;
  onAddNode?: (type: TreeNodeType, parent?: TreeNode) => void;
  loading?: boolean;
}

const ConfigTree: React.FC<ConfigTreeProps> = ({
  treeData,
  selectedKeys,
  expandedKeys,
  onSelect,
  onExpand,
  onAddNode,
  loading,
}) => {
  // 将 TreeNode 转换为 Ant Design Tree 的 DataNode
  const convertToDataNode = (node: TreeNode): DataNode => {
    return {
      key: node.key,
      title: (
        <span>
          {getIcon(node.type)} {node.title}
        </span>
      ),
      children: node.children?.map(convertToDataNode),
      isLeaf: node.isLeaf,
    };
  };

  // 获取节点图标
  const getIcon = (type: TreeNodeType) => {
    switch (type) {
      case 'service':
        return <AppstoreOutlined style={{ color: '#1890ff' }} />;
      case 'page':
        return <AppstoreOutlined style={{ color: '#52c41a' }} />;
      case 'component':
        return <AppstoreOutlined style={{ color: '#fa8c16' }} />;
      case 'dataset':
        return <DatabaseOutlined style={{ color: '#722ed1' }} />;
      case 'field':
        return <FileTextOutlined style={{ color: '#13c2c2' }} />;
      case 'thinking-mode':
        return <ThunderboltOutlined style={{ color: '#eb2f96' }} />;
      default:
        return null;
    }
  };

  const dataNodes = treeData.map(convertToDataNode);

  return (
    <Tree
      treeData={dataNodes}
      selectedKeys={selectedKeys}
      expandedKeys={expandedKeys}
      onSelect={onSelect}
      onExpand={onExpand}
      showLine
      showIcon={false}
      blockNode
    />
  );
};

export default ConfigTree;
